/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import { QATAR_TITLE, QATAR_DESCRIPTION } from '../../Utils/Constants/SEO';
import ToursResultFunc from '../ToursResult/ToursResultFunc';
import { QATAR_NAME } from '../../Utils/Constants/GlobalConstants';
import { getCountry } from '../../Utils/CommonUtils';
import { getCurrentYear } from '../../Utils/DateUtil';

class Qatar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = () => (
    <div>
      <div className="content_block">
        <h1 className="text_h1">{`🌴 Туры в Катар из Минска ${getCurrentYear()}`}</h1>
        <p className="text_p">
          Катар — страна, где древние пустыни встречают футуристические
          небоскребы, а гостеприимство местных жителей создает неповторимую
          атмосферу.
        </p>
        <p className="text_p">
          Для туристов из Минска это направление стало особенно привлекательным:
          короткий перелет (всего 6 часов прямым рейсом «Белавиа»), бесплатная
          виза на 30 дней по прилету и роскошный отдых по ценам ниже, чем в ОАЭ.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">✨ Почему выбирают Катар?</h2>
        <p className="text_p">
          1. Идеальный сезон: Лучшее время для поездки — с октября по апрель
          (температура +20...+30°C). Летом столбик термометра поднимается до
          +50°C, но отели и торговые центры оснащены мощными кондиционерами.
        </p>
        <p className="text_p">
          2. Роскошные пляжи: Доха славится ухоженными песчаными пляжами с
          бирюзовой водой Персидского залива. Большинство — частные (при
          отелях), но есть и платные общественные, например, Катара-Бич (вход
          около 27 $). Для уединения подойдут Fuwairit Beach, Zekreet Beach или
          Simaisma Beach.
        </p>
        <p className="text_p">
          ⚠️ Важно! На общественных пляжах запрещено загорать в бикини, а вот на
          территории отелей — разрешено.
        </p>
        <p className="text_p">
          Отели на любой вкус: от бюджетных городских отелей типа Swiss Belinn
          Hotel, Shraao Doha, Al Aseel Hotel Doha до роскошных Rixos Gulf Hotel
          Doha 5* и The Ritz-Carlton Doha 5*.
        </p>
      </div>
      <div className="content_block">
        <p className="text_p">
          Совет: Раннее бронирование позволяет сэкономить до 30% и гарантирует
          размещение в топовых отелях.
        </p>
        <p className="text_p">
          Активный отдых: Сафари в пустыне: Джип-туры, катание на верблюдах,
          сэндбординг и ночь в бедуинском лагере с ужином под звездами.
        </p>
        <p className="text_p">
          Дайвинг и сноркелинг: Лучшие места — около Дукана и Месаиды.
        </p>
        <p className="text_p">
          Шопинг и культура: Рынок Сук Вакиф, музей Исламского искусства,
          «Жемчужина Катара» (искусственный остров).
        </p>
        <p className="text_p">
          💡 Полезные советы для туристов из Минска: Виза оформляется по
          прибытии в аэропорту Дохи (срок — до 30 дней).
        </p>
        <p className="text_p">Трансфер: Прямые рейсы «Белавиа» Минск–Доха.</p>
        <p className="text_p">
          Правила: Запрещено фотографировать военные объекты и появляться в
          нетрезвом виде в общественных местах. Алкоголь нельзя ввозить даже из
          Duty Free — его изымут на таможне и вернут при выезде.
        </p>
        <p className="text_p">
          Связь: Купите SIM-карту Ooredoo или Vodafone для дешевых звонков в РБ
          (1.5 QAR/мин).
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">✅ Заключение: Почему Катар вместо Дубая?</h2>
        <p className="text_p">
          Катар предлагает тот же уровень роскоши (Five Seasons, St. Regis), но
          без толп туристов и пафоса. Здесь дешевле шопинг, доступнее экскурсии
          в пустыню и уникальные музеи вроде «Розы пустыни». А прямое сообщение
          с Минском делает поездку максимально комфортной. Готовы к путешествию?
          Забронируйте тур прямо на сайте с экономией до 25% - остались вопросы
          - свяжитесь через форму связи! 🌟
        </p>
      </div>
    </div>
  );

  render() {
    const text = this.getText();
    return (
      <div className="content">
        <Helmet>
          <title>{QATAR_TITLE}</title>
          <meta name="description" content={QATAR_DESCRIPTION} />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tourhunter.by/qatar/" />
          <meta property="og:title" content={QATAR_TITLE} />
          <meta property="og:description" content={QATAR_DESCRIPTION} />

          <link rel="canonical" href="https://tourhunter.by/qatar/" />
        </Helmet>
        <ToursResultFunc countryFilter={getCountry(QATAR_NAME)} text={text} />
      </div>
    );
  }
}

export default Qatar;
